import styled from 'styled-components';
import { iconExternal } from '../../../ui-components/design-tokens';
import { playFontIcon } from '../../../ui-components/typography/helpers';
import { VisuallyHidden } from '../../../ui-components/utils.styles';

export const StyledExternalIcon = styled.span`
    display: inline-block;
    vertical-align: top;
    margin-right: 0.2em;

    &:before {
        ${playFontIcon(1.5, iconExternal)}
    }
`;

export const StyledHiddenA11yText = styled.span`
    ${VisuallyHidden}
`;
